<div class="position-relative select-dropdown d-flex align-items-center justify-content-between gap-2 w-100" [class.full-width]="fullWidth()" [class.disabled]="disabled()" [class.secure-width]="secureWidth()" (click)="optionSelect.open()">
    @if (selectedOptionLabel())
    {
        <p class="active-label nunito-semibold">{{selectedOptionLabel() | translate}}</p>
    }
    @else 
    {
        <p class="color-gray-40 nunito-semibold">{{fieldName() | translate}}{{getRequiredMark()}}</p>
    }
    @if(!disabled())
    {
        <svg-icon src="assets/icons/chevron-down.svg" class="dropdown-icon d-flex align-items-center" />
    }
    <mat-select #optionSelect [formControl]="control()" class="option-select position-absolute invisible w-100 h-100" >
        @for (option of options(); track $index)
        {
            <mat-option [value]="option.value" [disabled]="option.disabled">{{option.label | translate}}</mat-option>
        }
    </mat-select>
</div>
